import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import {
  TUpdateComplianceFormRequestSchema,
  TUpdateComplianceFormResponseSchema,
} from "./updateComplianceForm.schema";

export const updateComplianceForm = (axios: IAxiosInstance) => {
  return async (body: TUpdateComplianceFormRequestSchema) => {
    const response = await axios.noRetry.patch<
      IApiResponse<TUpdateComplianceFormResponseSchema>
    >(`/api/business-cards/compliance-form`, body);

    return response.data;
  };
};
